/**
 * 积分规则接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class BulletinService {
  //基础平台微服务api
  prefix: string = environment.seekerWebAPI;

  constructor(
    private http: SwHttpClientService
  ) {
  }

  //#region 
    /**
   * 平台公告分页查询
   */
     queryBulletinPageList(param) {
     // const url = this.prefix + 'common/queryBulletinPage';
     const url = this.prefix + 'common/queryNotice?size=999';
     
      return this.http.Post(url, param);
    }

    /**
   * 根据ID查询
   */
     queryBulletinById(param) {
      const url = this.prefix + 'notice/queryById';
      return this.http.Post(url, param);
    }
  //#endregion 
}
